import { pricePropsFrom } from '@udemy/react-card-components';
import { PURCHASE_PRICE_TYPES } from '@udemy/shopping';

/** A subset of Course API for tracking */

// Augment course with CourseTracking

/**
 * Injects `trackingEventContext` into `pricePropsFrom` function from
 * `@udemy/react-card-components`.
 *
 * @remarks
 *
 * Augments the existing convenience function to pluck course card price props
 * from the `course` object. Adds a tracking event context for the rendered
 * price text component.
 *
 * @see {@link `@udemy/browse-course#StaticPriceText`} and
 * {@link `@udemy/browse-course#DynamicPriceText`}.
 */
export const pricePropsWithTrackingFrom = ({
  course,
  priceTextProps
}) => ({
  ...pricePropsFrom({
    course,
    priceTextProps
  }),
  ...priceTrackingEventContext({
    course
  }),
  ...priceTextProps
});

/**
 * Generates a `trackingEventContext` for rendered course price text.
 */
export const priceTrackingEventContext = ({
  course
}) => ({
  trackingEventContext: {
    buyableId: course.id,
    priceType: PURCHASE_PRICE_TYPES.individual_buyable,
    buyableType: 'course',
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    buyableTrackingId: course.frontendTrackingId || course.tracking_id
  }
});
//# sourceMappingURL=course-card-price-events.js.map